// extracted by mini-css-extract-plugin
export default {"myLocationDot":"KakaoMap_myLocationDot__+fNh9","myLocationShadow":"KakaoMap_myLocationShadow__HwLJb","flickerAnimation":"KakaoMap_flickerAnimation__L7Y0y"};